import { D as e, I as t, o as n } from "./_plugin-vue_export-helper-CTQVpqU-.js";
//#region src/webcomponents/utils/shadow-dom.ts
var r = Symbol("shadowRoot");
function i() {
	let e = n();
	e != null && t(r, e);
}
function a() {
	let t = e(r);
	return t ?? console.error("useShadowRoot: provideShadowRoot must be called in root CustomElement.ce.vue"), t;
}
//#endregion
export { a as n, i as t };
